import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { FEATURE_FLAGS } from '../../../../common/constants/feature-flags.constants';
import { FeatureFlagsService } from '../../../../common/services/feature-flags/feature-flags.service';
import { RequestService } from '../../../../common/services/request/request.service';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { EmployeeRequestContextAdapter } from './employee-request-context.adapter';
import {
  RequestAfterActionContext,
  RequestNavigationTarget,
} from './request-context.adapter';

@Injectable({ providedIn: 'root' })
export class DelegatedRequestContextAdapter extends EmployeeRequestContextAdapter {
  private readonly delegatedRequestService = inject(RequestService);
  private readonly delegatedTenantService = inject(TenantService);
  private readonly featureFlags = inject(FeatureFlagsService);

  override getAfterActionNavigation(
    _context: RequestAfterActionContext
  ): RequestNavigationTarget {
    const commands = [
      this.delegatedTenantService.tenantPath(EMPLOYEE_ROUTES.MY_INBOX.LIST),
    ];
    if (
      this.featureFlags.getFeatureFlagValue(
        FEATURE_FLAGS.INBOX.delegated_to_me_tab
      )
    ) {
      return {
        commands,
        queryParams: {
          tab: EMPLOYEE_ROUTES.MY_INBOX.TABS.delegatedToMe,
        },
      };
    }
    return {
      commands,
      queryParams: {
        tab: EMPLOYEE_ROUTES.MY_INBOX.TABS.assignedToMe,
        [EMPLOYEE_ROUTES.MY_INBOX.SUB_TAB_QUERY_PARAM]:
          EMPLOYEE_ROUTES.MY_INBOX.TABS.taskDelegation,
      },
    };
  }

  override takeStepAction(
    form: unknown,
    stepId: string | number
  ): Observable<unknown> {
    return this.delegatedRequestService.takeActionDelegated(form, stepId);
  }
}
